<template>
  <v-bottom-navigation app class="d-flex menu-bar" fixed grow tag="footer">
    <v-btn
      v-for="nav in navigation"
      :id="nav.id"
      :key="nav.text"
      :class="[
        'menu-bar__menu-btn',
        'gtm-click',
        isMatchingRoute(nav) ? 'menu-bar__menu-btn--active' : null
      ]"
      :to="nav.to ?? undefined"
    >
      <div class="text-center">
        <v-badge
          class="w-100 font-weight-bold"
          color="primary"
          :content="nav.badgeContent"
          :offset-x="32"
          :offset-y="14"
          :model-value="Boolean(nav.badge)"
        >
          <icon>{{ nav.icon.name }}</icon>
        </v-badge>
        <p class="menu-bar__menu-btn__text text-black ma-0">
          {{ nav.text }}
        </p>
      </div>
    </v-btn>
  </v-bottom-navigation>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

defineProps({
  drawer: {
    type: Boolean,
    default: () => false
  }
});

const store = useStore();
const route = useRoute();
const router = useRouter();

const hasGamifiedDealsWithOrders = computed(
  () => store.getters['deals/hasGamifiedDealsWithOrders']
);
const messages = computed(() => store.state.messages);
const offer = computed(() => store.state.offer);
const partner = computed(() => store.state.partner);
const partnerUser = computed(() => store.state.partnerUser);
const cartItemCount = computed(
  () => store.getters['cartOrders/getCartLength'] ?? 0
);
const unreadCount = computed(() => messages.value?.unread ?? 0);

const navigation = computed(() => {
  const query = { t: window.token };
  const items = [
    ...(partnerUser.value?.id
      ? [
          {
            icon: {
              name:
                partner.value?.id && partner.value.id === 942
                  ? '942'
                  : 'Experiences'
            },
            to: { name: 'Experiences', query },
            text:
              partner.value?.id && partner.value.id === 942
                ? 'Check-In'
                : 'Experiences',
            id: 'menu_experiences_btn',
            badge: false
          }
        ]
      : []),
    {
      icon: { name: 'Explore' },
      to: { name: 'Explore', query },
      text: 'Explore',
      id: 'menu_explore_btn',
      badge: false
    },
    ...(hasGamifiedDealsWithOrders.value || offer.value.use_points
      ? [
          {
            icon: { name: 'Rewards' },
            to: { name: 'Rewards', query },
            text: 'Rewards',
            id: 'menu_rewards_btn',
            badge: false
          }
        ]
      : []),
    {
      icon: { name: 'Bag' },
      to: { name: 'ReviewOrder', query },
      text: 'My Bag',
      id: 'menu_bag_btn',
      badge: cartItemCount.value,
      badgeContent: cartItemCount.value
    },
    {
      icon: { name: 'More' },
      to: { name: 'More', query },
      text: 'More',
      menu: true,
      id: 'menu_more_btn',
      badge: unreadCount.value > 0 ? unreadCount.value : false,
      badgeContent: unreadCount.value
    }
  ];

  return items.filter(item => {
    if (!item.to?.name) return true;
    return router.hasRoute(item.to.name);
  });
});

const isMatchingRoute = nav => {
  const { parent } = route.meta;
  return route.name === nav.to.name || (parent && parent === nav.to.name);
};
</script>

<style lang="scss">
.menu-bar {
  border-top: solid 1px rgb(var(--v-theme-grey-lighten-2, 238 238 238));
  box-shadow: none !important;
  height: 90px !important;
  overflow: hidden;

  .v-btn {
    min-width: 0;
    text-transform: none;
    padding-bottom: 20px !important;
  }

  .menu-bar__menu-btn__text {
      padding-right: 1px !important;
  }

  .v-btn > .v-btn__content {
    align-items: center;
    color: inherit;
    display: flex;
    flex: 1 0 auto;
    justify-content: inherit;
    line-height: normal;
    position: relative;
    transition: inherit;
    transition-property: opacity;
  }

  // .v-btn > .v-btn__content > .text-center {
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  //   width: 100%;
  //   gap: 2px;
  // }

  .v-btn .v-badge {
    display: flex;
    justify-content: center;
    padding-bottom: 3px !important;
    font-weight: 700 !important;
  }

  .menu-bar__menu-btn .v-badge__badge {
    font-weight: 700 !important;
    font-size: 12px !important;
  }

  &__menu-btn {
    padding-bottom: 20px !important;
    opacity: 0.65;

    &__text {
      font-weight: 400;
      font-size: 10px;
      color: black;
    }

    &--active {
      opacity: 1;

      &::before {
        background: none;
        content: '';
        border-bottom: 4px solid rgb(var(--v-theme-primary));
        position: absolute;
        height: 8px;
        top: -4px;
        left: 0;
        width: 100%;
        box-shadow: none;
        border-radius: 4px;
        opacity: 1 !important;
      }
    }
  }

  .v-btn__overlay {
      background-color: unset !important;
  }

  /*  &::after {
		position: absolute;
		content: 'asdf';
		width: 100%;
		height: 30px;
		opacity: 0.3;
		background: linear-gradient(0deg, clothoid-gradient(#000000));
		bottom: 100%;
		left: 0;
		z-index: 1;
	}*/
}
</style>
